import type { StreakRecord } from '@/domain/streak'

export function StreakIndicator({ streak }: { streak: StreakRecord | null }) {
  const current = streak?.currentStreak ?? 0
  return (
    <div className="cyber-panel p-5 text-center">
      <p className="font-display text-2xl font-bold text-amber-300">{current > 0 ? `🔥 ${current}` : '—'}</p>
      <p className="text-xs text-white/50">{current === 1 ? 'day streak' : 'day streak'}</p>
      {streak && streak.longestStreak > current && (
        <p className="mt-1 text-[11px] text-white/30">Best: {streak.longestStreak}</p>
      )}
    </div>
  )
}
